// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import {
  CommercialAgreementOffer,
  CommercialAgreementOffer_Accept_Result,
} from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Offer';
import { UtilityFees } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Types/module';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useParties } from '../../../contexts/PartiesContext';
import useDsoParty from '../../queries/cn/useDsoParty';

export const useAcceptCommercialAgreementOffer: () => UseMutationResult<
  CommercialAgreementOffer_Accept_Result,
  string,
  {
    commercialAgreementCid: ContractId<CommercialAgreementOffer>;
    operator: string;
    user: string;
    feeReceiver: string;
    utilityFees: UtilityFees;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { party } = useParties();
  const dsoParty = useDsoParty()?.data || '';

  return useMutation({
    mutationKey: ['acceptCommercialAgreementOffer', ledgerApi, party, dsoParty],
    mutationFn: async ({ commercialAgreementCid, operator, user, feeReceiver, utilityFees }) => {
      return ledgerApi.acceptCommercialAgreementOffer(
        commercialAgreementCid,
        operator,
        user,
        feeReceiver,
        utilityFees,
        dsoParty,
      );
    },
  });
};
